import {ImageRotator} from '../components/ImageRotator'

export function run() {
  console.log('hi home');

  const rotator = new ImageRotator('.jkd-image-rotator');
  console.log(rotator);
  rotator.run();
}
